<template>
    <jet-dialog-modal @close="$emit('close')" :show="true">
        <template #title>
            Your Account is Paused
        </template>

        <template #content>
            <div class="">
                Upgrade to a plan to be able to send messages again.
            </div>
        </template>

        <template #footer>
            <Link :href="route('subscriptions.index')" class="">
                <jet-button type="button" primary>View Plans</jet-button>
            </Link>
        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'YourAccountIsPausedModal',
    emits: ['close'],
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },

}
</script>